import React, {  } from "react"
import { ParametrosDaSessaoARContext } from ".";
import { EnumTipoUsuario } from "../../../../Models/Domain/AreaRestrita/Sessao";

export type ParametrosDaSessaoDaEscola = {
    tipoDeUsuario: EnumTipoUsuario.Escola,
}

export const ComParametrosDaSessaoDaEscola: React.FC<{
    children: React.ReactNode
}> = (props) => {

    const parametros: ParametrosDaSessaoDaEscola = {
        tipoDeUsuario: EnumTipoUsuario.Escola
    };

    return <React.Fragment>
        <ParametrosDaSessaoARContext.Provider value={parametros}>
            {props.children}
        </ParametrosDaSessaoARContext.Provider>
    </React.Fragment>
}